import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { lionSelectors, LionTranslate } from '@rosetta/react-lion';
import styled from '@emotion/styled';

import { launchpadSelectors } from '../reducer/launchpad-reducer';
import { goalsSelectors, goalsActions } from '../reducer/goals-reducer';
import { dashboardGoalMessages } from '../services/goals-helpers';
import { LaunchpadButton } from '../../../styles/LaunchpadButton';
import {
  appTextColor,
  white,
  darkModalBackdropColor,
  mobileGoalLanguageGrey,
  superLightGrey
} from '../../../styles/colors';
import { appMinWidth } from '../../../styles/constants';

import editImage from '../../../assets/images/icon_edit.svg';
import mobileMyGoalsImage from '../../../assets/images/icon_duration.svg';

import postGoalImage from '../../../assets/images/img-messaging.svg';
import preGoalImage from '../../../assets/images/img-msg-pre-goal.svg';

import postGoalImageMobile from '../../../assets/images/img-messaging-mobile.png';
import preGoalImageMobile from '../../../assets/images/img-msg-pre-goal-mobile.png';

import { EditGoalsContainer as EditGoals } from './EditGoals';
import { authSelectors } from '@rosetta/react-auth';
import { withWindowDimensions } from '@rosetta/react-common-ui';
import { isMobile as isMobileDetected } from 'react-device-detect';

const DashboardBox = styled.div(() => {});

const DashboardContentContainerDiv = styled.div((props) => {
  let style = {
    fontFamily: 'inherit',
    width: !props.isMobile ? '1076px' : '100%',
    padding: !props.isMobile ? '0' : '0 16px',
    fontSize: '14px',
    margin: 'auto'
  };

  return style;
});

const MobileUserGoals = styled.div((props) => {
  let style = {
    color: white,
    fontSize: '16px',
    padding: '100px 120px 27px 16px',
    backgroundRepeat: 'no-repeat'
  };
  if (props.hasMetGoal) {
    style.backgroundPosition = '98% top';
    style.backgroundImage = 'url(' + postGoalImageMobile + ')';
  } else {
    style.backgroundPosition = '98% bottom';
    style.backgroundImage = 'url(' + preGoalImageMobile + ')';
  }

  return style;
});

const MyGoalsContainer = styled.div((props) => {
  let style = {
    float: !props.isMobile ? 'left' : 'none',
    width: !props.isMobile ? '50%' : '100%',
    padding: !props.isMobile ? '22px 45px 0 45px' : '16px 0',
    margin: !props.isMobile ? '0' : 'auto'
  };

  return style;
});

const GoalContainer = styled.div((props) => {
  let style = {
    fontFamily: 'inherit',
    marginBottom: '30px',
    position: 'relative',
    color: !props.isMobile ? white : appTextColor
  };
  if (props.isMobile) {
    style.backgroundColor = white;
    style.boxShadow = '2px 2px 6px 0 rgba(0, 0, 0, 0.07)';
    style.borderRadius = '6px';
    style.textAlign = 'center';
  }

  return style;
});

const GoalMessage = styled.div((props) => {
  let style = {
    backgroundColor: '#4a4a4a',
    color: white,
    borderRadius: '4px',
    width: '100%',
    boxShadow: '2px 2px 6px 0 rgba(0, 0, 0, 0.07)',
    height: '60px',
    marginBottom: '20px',
    textAlign: 'center',
    backgroundRepeat: 'no-repeat',
    fontSize: '21px',
    lineHeight: '60px',
    fontWeight: '200',
    ' b': {
      fontWeight: '500'
    }
  };
  if (props.isMobile) {
    style.display = 'none';
  }
  if (props.hasMetGoal) {
    style.backgroundPosition = '0px -76px';
    style.backgroundImage = 'url(' + postGoalImage + ')';
  } else {
    style.backgroundPosition = '108px 0px';
    style.backgroundImage = 'url(' + preGoalImage + ')';
  }
  return style;
});

const GoalMessageMobile = styled.div((props) => {
  let style = {
    color: white,
    fontSize: '16px',
    fontWeight: '200',
    ' b': {
      fontWeight: '500'
    }
  };
  if (!props.isMobile) {
    style.display = 'none';
  }
  return style;
});

const MyGoalsValue = styled.div(() => {
  let style = {
    fontWeight: '500',
    fontSize: '16px'
  };

  return style;
});

const MyGoalsWrapper = styled.div((props) => {
  let style = {
    fontSize: '13px',
    textAlign: 'center',
    ':first-child': {},
    ':last-child': {}
  };

  if (!props.isMobile) {
    style.float = 'left';
    style.width = '22%';
    style[':last-child'].width = '30%';
  } else {
    style.display = 'inline-block';
    style.padding = '5px 27px';
    style.verticalAlign = 'middle';
    style[':last-child'].padding = '0';

    if (props.isMinutes) {
      style.borderRight = '1px solid' + superLightGrey;
      style.paddingLeft = '10px';
    }
  }

  return style;
});

const EditGoalsButton = styled(LaunchpadButton)((props) => {
  let style = {
    height: '36px',
    fontSize: '16px',
    lineHeight: '20px',
    padding: '4px 12px',
    display: 'inline-block',
    width: 'auto'
  };
  if (props.isMobile) {
    style.borderRadius = '4px';
  }
  return style;
});

const EditGoalImage = styled.div(() => {
  let style = {
    backgroundImage: 'url(' + editImage + ')',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center 9px',
    width: '20px',
    height: '20px',
    display: 'inline-block'
  };
  return style;
});

const MyGoalsTitle = styled.div((props) => {
  let style = {
    float: 'left',
    width: '25%',
    fontWeight: '500',
    fontSize: '18px'
  };
  if (props.isMobile) {
    style.display = 'none';
  }

  return style;
});

const MyGoalsMobileIcon = styled.div((props) => {
  let style = {
    display: 'inline-block',
    height: '24px',
    width: '24px',
    backgroundImage: 'url(' + mobileMyGoalsImage + ')',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '',
    verticalAlign: 'middle'
  };
  if (!props.isMobile) {
    style.display = 'none';
  }

  return style;
});

const LanguageLevelContainer = styled.div((props) => {
  let style = {
    height: !props.isMobile ? '86px' : 'auto',
    padding: !props.isMobile ? '22px 100px 0 100px' : '6px 0'
  };
  if (!props.isMobile) {
    style.float = 'right';
    style.width = '50%';
    style.borderLeft = '1px solid' + white;
    style.height = '86px';
  } else {
    style.textAlign = 'center';
    style.backgroundColor = mobileGoalLanguageGrey;
    style.borderRadius = '6px 6px 0 0';
  }

  return style;
});

const LanguageSeparator = styled.div((props) => {
  let style = {
    display: !props.isMobile ? 'none' : 'inline-block',
    margin: '0 6px',
    fontSize: '15px'
  };

  return style;
});

const LanguageWrapper = styled.div((props) => {
  let style = {
    textAlign: 'center',
    display: !props.isMobile ? 'table-cell' : 'inline-block',
    verticalAlign: 'middle'
  };
  if (!props.isMobile) {
    style.width = props.isCefr ? '25%' : '40%';
    style.borderLeft = props.isCefr ? '1px solid' + white : 'none';
  }

  return style;
});

const LanguageHeader = styled.div((props) => {
  let style = {
    display: !props.isMobile ? 'block' : 'none',
    fontSize: '13px',
    color: white,
    lineHeight: '16px'
  };

  return style;
});

const LanguageValue = styled.div((props) => {
  let style = {
    fontSize: !props.isMobile ? '18px' : '14px',
    fontWeight: props.isMobile && props.isCefr ? 'normal' : '500'
  };

  return style;
});

const ClearDiv = styled.div(() => {
  let style = {
    clear: 'both'
  };

  return style;
});

const TriggerDiv = styled.div(() => {
  let style = {
    position: 'absolute',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px',
    minWidth: appMinWidth,
    backgroundColor: 'transparent'
  };
  return style;
});

const ModalBackdrop = styled.div(() => {
  let style = {
    position: 'fixed',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px',
    display: 'block',
    backgroundColor: darkModalBackdropColor,
    overflow: 'auto',
    zIndex: '998'
  };
  return style;
});

const UserName = styled.div((props) => {
  let style = {
    fontSize: '20px',
    lineHeight: '30px',
    marginBottom: '0',
    fontWeight: '200',
    ' b': {
      fontWeight: '500'
    }
  };

  return style;
});

class DashboardGoals extends PureComponent {
  render = () => {
    if (!this.props.lionLoaded) {
      return null;
    }
    const isMobile = isMobileDetected;
    const cefrLevel = this.props.userInfo && this.props.userInfo.targetLanguage.level;
    const learningLanguage =
      this.props.userInfo && this.props.userInfo.targetLanguage.language
        ? this.props.userInfo.targetLanguage.language
        : 'en-US';

    let DashboardContentContainer = null;
    let MobileUserMessageContainer = null;

    if (!this.props.isCatalyst || !this.props.isDashboard) {
      DashboardContentContainer = null;
    } else {
      let learnerUsageGoalDays =
        this.props.userInfo && this.props.userInfo.usageGoalDays ? this.props.userInfo.usageGoalDays : 3;
      let learnerUsageGoalMinutes =
        this.props.userInfo && this.props.userInfo.usageGoalMinutes ? this.props.userInfo.usageGoalMinutes : 60;
      let learnerUsageGoalMilliseconds = learnerUsageGoalMinutes * 60000;
      let hasMetGoal = false;
      let randomMessage = null;
      let EditGoalsContainer = null;

      function getGoalSessions(loginUsage) {
        // pluck the usageDuration out of this week's loginUsage.
        return loginUsage.map((durationArray) => durationArray['usageDuration']);
      }
      // filter those durations for items >= learnerUsageGoalMilliseconds.
      let goalSessionsArray = [];
      if (this.props.dashboard.loginUsage) {
        goalSessionsArray = getGoalSessions(this.props.dashboard.loginUsage).filter(
          (duration) => duration >= learnerUsageGoalMilliseconds
        );
      }

      // if length of these items are >= learnerUsageGoalDays, then hasMetGoal.
      hasMetGoal = goalSessionsArray.length >= learnerUsageGoalDays;

      if (hasMetGoal) {
        randomMessage =
          dashboardGoalMessages.postGoal[Math.floor(Math.random() * dashboardGoalMessages.postGoal.length)];
      } else if (this.props.dashboard.showDashboardTutoring) {
        randomMessage =
          dashboardGoalMessages.preGoalWithTutoring[
            Math.floor(Math.random() * dashboardGoalMessages.preGoalWithTutoring.length)
          ];
      } else {
        randomMessage = dashboardGoalMessages.preGoal[Math.floor(Math.random() * dashboardGoalMessages.preGoal.length)];
      }

      if (this.props.showDashboardGoalsPopup) {
        EditGoalsContainer = (
          <TriggerDiv>
            <ModalBackdrop />
            <EditGoals />
          </TriggerDiv>
        );
      }

      if (isMobile) {
        MobileUserMessageContainer = (
          <MobileUserGoals hasMetGoal={hasMetGoal}>
            <UserName
              data-qa="DashboardUserName"
              dangerouslySetInnerHTML={{
                __html: this.props
                  .getLionTranslatedString('_dashboard_salutation_' + learningLanguage)
                  .replace('{name}', this.props.userName)
              }}
            />
            <GoalMessageMobile
              hasMetGoal={hasMetGoal}
              dangerouslySetInnerHTML={{ __html: this.props.getLionTranslatedString(randomMessage) }}
              isMobile={isMobile}
            />
          </MobileUserGoals>
        );
      }

      DashboardContentContainer = (
        <DashboardContentContainerDiv isMobile={isMobile}>
          {EditGoalsContainer}

          <GoalContainer isMobile={isMobile}>
            <LanguageLevelContainer isMobile={isMobile}>
              <LanguageWrapper isMobile={isMobile}>
                <LanguageValue isMobile={isMobile}>
                  {this.props.getLionTranslatedString('language_' + learningLanguage)}
                </LanguageValue>
                <LanguageHeader isMobile="{isMobile}">
                  <LionTranslate lionkey="_dashboard_language" />
                </LanguageHeader>
              </LanguageWrapper>
              <LanguageSeparator isMobile={isMobile}>&#8226;</LanguageSeparator>
              {!!cefrLevel && (
                <LanguageWrapper isCefr isMobile={isMobile}>
                  <LanguageValue isMobile={isMobile} isCefr>
                    {cefrLevel}
                  </LanguageValue>
                  <LanguageHeader isMobile="{isMobile}">
                    <LionTranslate lionkey="_dashboard_level" />
                  </LanguageHeader>
                </LanguageWrapper>
              )}
            </LanguageLevelContainer>
            <MyGoalsContainer isMobile={isMobile}>
              <MyGoalsTitle isMobile={isMobile}>
                <LionTranslate lionkey="_dashboard_my_goals" />
              </MyGoalsTitle>
              <MyGoalsMobileIcon isMobile={isMobile} />
              <MyGoalsWrapper isMobile={isMobile} isMinutes>
                <MyGoalsValue
                  dangerouslySetInnerHTML={{
                    __html: this.props
                      .getLionTranslatedString('goals_minutes')
                      .replace('{minutes}', learnerUsageGoalMinutes)
                  }}
                />
                <LionTranslate lionkey="_dashboard_goals_per_day" />
              </MyGoalsWrapper>

              <MyGoalsWrapper isMobile={isMobile}>
                <MyGoalsValue
                  dangerouslySetInnerHTML={{
                    __html: this.props.getLionTranslatedString('goals_days').replace('{days}', learnerUsageGoalDays)
                  }}
                />
                <LionTranslate lionkey="_dashboard_weekly" />
              </MyGoalsWrapper>
              <MyGoalsWrapper isMobile={isMobile}>
                <EditGoalsButton onClick={() => this.props.setGoalsPopupView(true)} isMobile={isMobile}>
                  <LionTranslate lionkey="_dashboard_edit" />
                  <EditGoalImage />
                </EditGoalsButton>
              </MyGoalsWrapper>
            </MyGoalsContainer>

            <ClearDiv />
          </GoalContainer>

          <GoalMessage
            hasMetGoal={hasMetGoal}
            dangerouslySetInnerHTML={{ __html: this.props.getLionTranslatedString(randomMessage) }}
            isMobile={isMobile}
          />
        </DashboardContentContainerDiv>
      );
    }
    return (
      <DashboardBox>
        {MobileUserMessageContainer}
        {DashboardContentContainer}
      </DashboardBox>
    );
  };
}

const mapStateToProps = (state, ownprops) => ({
  lionLoaded: lionSelectors.getLionAppResourcesLoaded(state),
  getLionTranslatedString: (key, placeholders, values, altLocale) =>
    lionSelectors.getLionTranslatedString(state, key, placeholders, values, altLocale),
  dashboard: launchpadSelectors.dashboard(state),
  userName: authSelectors.userName(state),
  userInfo: authSelectors.userInfo(state),
  showDashboardGoalsPopup: goalsSelectors.showDashboardGoalsPopup(state)
});

const wrapActions = {
  setGoalsPopupView: goalsActions.setGoalsPopupView
};

export const DashboardGoalsContainer = connect(
  mapStateToProps,
  wrapActions
)(withWindowDimensions(DashboardGoals));
//export const UserSalutationContainer = connect(mapStateToProps, wrapActions)(UserSalutation);



// WEBPACK FOOTER //
// ./src/modules/launchpad/components/DashboardGoals.jsx